import script from "./accountIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./accountIndex.vue?vue&type=script&setup=true&lang=js"

import "./accountIndex.vue?vue&type=style&index=0&id=91fc0fc6&scoped=true&lang=css"

import exportComponent from "D:\\work\\hw-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91fc0fc6"]])

export default __exports__